export default __webpack_public_path__ + "static/media/brand_03.d44f704c.png";